class ClothingSizesModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'modal', 'close']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    this.listeners.add(this.els.backdrop.element, 'click', () =>
      this.closeModal(),
    )

    this.listeners.add(this.els.close.element, 'click', () => this.closeModal())
  }

  onTriggerClick () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'false')

    document.body.style.setProperty('overflow', 'hidden')
  }

  closeModal () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'true')

    document.body.style.removeProperty('overflow')
  }
}

if (!window.customElements.get('clothing-sizes-modal')) {
  window.customElements.define('clothing-sizes-modal', ClothingSizesModal)
}
